export const MAP_TEMPLATES: Record<'1' | '2' | '3', string> = {
  1: 'The payment system is currently unstable. Transactions may take longer than usual to process.',
  2: "The national payment system is currently facing temporary technical issues. As a result, payments may take a bit longer than usual. Don't worry! We are monitoring the situation and doing our best to speed things up. Thank you for your patience!",
  3: "There is currently a technical issues with the NIBSS system, so payments may take a bit longer than usual to process. Don't worry! We are on it and doing everything possible to speed things up. Thank you for your patience!",
}

export const MAP_TEMPLATE_KEYS: Record<keyof typeof MAP_TEMPLATES, string> = {
  1: 'info.gateway-additional-info-ps-unstable',
  2: 'info.gateway-additional-info-ps-tech-issues',
  3: 'info.gateway-additional-info-nibss-issues',
}

export const OPTIONS_TEMPLATE = [
  { label: 'Standard Template 1', value: '1' },
  { label: 'Standard Template 2', value: '2' },
  { label: 'Standard Template 3', value: '3' },
]

const MAP_TEMPLATE_TEXT_BY_KEY: Record<string, string> = Object.fromEntries(
  Object.entries(MAP_TEMPLATE_KEYS).map(([template, key]) => [
    key,
    MAP_TEMPLATES[template as keyof typeof MAP_TEMPLATES],
  ]),
)

export const getNoticeText = (message?: string | null): string => {
  if (!message) return ''

  try {
    const { key } = JSON.parse(message)

    if (typeof key === 'string') return MAP_TEMPLATE_TEXT_BY_KEY[key] ?? key
  } catch {
    return message
  }

  return message
}
